import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Datatable } from "tw-elements";
import { ClearSession, SessionCheck } from "../Components/Common/Helper";
import * as Constants from "../Constants/constants";
import ErrorModal from "../Components/Common/ErrorModal";
import { TETabs, TETabsContent, TETabsItem, TETabsPane } from "tw-elements-react";
import { motion } from "framer-motion";
import { EnumOperacao } from "../Model/Estimativa/EnumOperacao";

const formatCellTotal = (cell, value) => {
  cell.classList.toggle("bg-white", true);
  cell.classList.add("bg-[#f5f7f6]");
  cell.classList.add("text-[#000000]");
};

const formatCellServices = (cell, value) => {
  cell.classList.add("font-semibold");
  //cell.classList.add("text-center");
};

const formatCellTotalGeral = (cell, value) => {
  if (value.toString() === "Total Geral") {
    cell.classList.add("bg-[#f5f7f6]");
    cell.classList.add("text-[#000000]");
  }
};

const gridOptions =
{
  bordered: true,
  hover: true,
  noFoundMessage: "Não foram encontrados serviços para esta categoria.",
  loadingMessage: "Carregando resultados...",
  striped: true,
  fixedHeader: true,
  pagination: false,
  loading: true,
  //selectable: true
};

export default function FinalPortResult() {
  const location = useLocation();
  const tipoOperacaoDTO = location.state;
  const enumOperacao = EnumOperacao;
  const navigate = useNavigate();
  const sessionCheck = async () => { return await SessionCheck() };
  const clearSession = async () => { return await ClearSession() };
  const [errors, setErrors] = useState({});
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [verticalActive, setVerticalActive] = useState("procoparmazenagem");
  const [pdfGenerating, setpdfGenerating] = useState(false);
  const handleVerticalClick = (value) => {
    if (value === verticalActive) {
      return;
    }
    setVerticalActive(value);
  };

  const dataTotal = {
    columns: [
      { label: 'Serviço', field: 'servico', format: formatCellTotal, sort: false },
      { label: 'Quantidade', field: 'quantidade', format: formatCellTotal, sort: false },
      { label: tipoOperacaoDTO.Operacao == enumOperacao.PortuariaNaoConteiner ? 'Qtd Horas' : 'Qtd Periodos', field: 'diasAplicados', format: formatCellTotal, sort: false },
      { label: 'Valor Base', field: 'valorUnitario', format: formatCellTotal, sort: false },
      { label: 'Valor Calculado', field: 'total', format: formatCellTotal, sort: false },
      { label: 'Valor Final', field: 'totalComImposto', format: formatCellTotal, sort: false },
    ],
    rows: [
    ],
  };
  /*Calcula o resultado para popular a tela.*/
  const calcularServicos =
    async (prTableTotal) => {
      const newErrors = {};
      
      try {
        const response = await fetch(
          Constants.FinalResultConstants.ENDPOINT_CALCULARRESULTADOPORTUARIOSIMULACAO,
          { ...Constants.CommonConstants.DEFAULT_POST_REQUEST_OPTIONS, body: JSON.stringify(tipoOperacaoDTO) }
        )

        const result = await response.json();

        if (result.success === true) {
          prTableTotal.update({ ...dataTotal, rows: result.responseObject[0] ?? [] }, { ...gridOptions, loading: false });
        }
        else {
          newErrors.result = result.userFriendlyMessage;
          console.log(result.technicalMessage);
          if (result.technicalMessage.startsWith("No session"))
            navigate('/StartSimulation');
        }

      }
      catch (error) {
        newErrors.result = "Não foi possível registrar as informações básicas, tente novamente mais tarde.";
        console.log(error);
      }
      finally {
        if (Object.keys(newErrors).length > 0) {
          setErrors(newErrors);
          setShowErrorModal(true);
        }
      }

    }

  async function handleCancelarClick(e) {
    e.preventDefault();
    await clearSession();
    navigate('/StartSimulation');
  }

  const handleGerarPDF = async (e) => {
    e.preventDefault();
    const newErrors = {};
    try {
      setpdfGenerating(true);
      const response = await fetch(
        Constants.FinalResultConstants.ENDPOINT_GERARRELATORIOFINAL,
        { ...Constants.CommonConstants.DEFAULT_POST_REQUEST_OPTIONS }
      )

      const result = await response.json();
      if (result.success === true) {

        const binaryData = atob(result.responseObject[0].file);
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const view = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          view[i] = binaryData.charCodeAt(i);
        }
        const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = result.responseObject[0].fileName;
        downloadLink.click();
      }
      else {
        newErrors.result = result.userFriendlyMessage;
        console.log(result.technicalMessage);
        if (result.technicalMessage.startsWith("No session"))
          navigate('/StartSimulation');
      }

    }
    catch (error) {
      newErrors.result = "Não foi possível gerar pdf da sua simulação, tente novamente mais tarde.";
      console.log(error);
    }
    finally {
      setpdfGenerating(false);
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        setShowErrorModal(true);
      }
    }
  };

  const [sessionChecked, setSessionChecked] = useState(false);
  useEffect(() => {
    sessionCheck().then(value => {
      if (value) {
        setSessionChecked(true);
      }
      else {
        navigate('/StartSimulation')
      }
    });

    if (sessionChecked) {

      const init = async () => {
        const { Tab, Datatable, initTE } = await import("tw-elements");
        initTE({ Tab, Datatable }, { allowReinits: true });
      };
      init();

      const tableTotal = new Datatable(document.getElementById('tableResult'));
      tableTotal.update(dataTotal, gridOptions);

      calcularServicos(tableTotal);
    }
  }, [sessionChecked]);


  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {sessionChecked &&
        <div className="items-center">
          <div className="container mx-auto pt-4 pb-4 lg:pt-8  lg:px-6 bg-white">
            <section>
              <div className="flex flex-wrap items-start justify-center">

                <div className="w-full shrink-0 grow-0 basis-auto lg:w-5/6 xl:w-4/6 px-3 mb-5">
                  <h2 className="text-3xl font-bold">4. Veja aqui o </h2>
                  <h2 className="text-orange-600 mb-1 text-3xl font-bold">resultado da simulação</h2>
                  <p className="text-gray-500 sm:max-w-md ">
                    Total agrupado por tipo de serviço e o total geral da sua simulação.
                    Clique em 'Gerar PDF' para exportar seus cálculos.
                  </p>

                  <div
                    id="tableResult"
                    className="border-t w-full border-gray-900/10 pb-2 !overflow-x-auto pt-4"
                  >
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-end gap-x-6 sm:w-full lg:w-11/12 xl:w-5/6">
                <button type="button" onClick={handleCancelarClick} className="text-sm font-semibold leading-6 text-gray-900">Reiniciar simulação</button>
                <button
                  type="button"
                  disabled={pdfGenerating}
                  onClick={handleGerarPDF}
                  className="rounded-md bg-orange-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                  {pdfGenerating ? "Aguarde..." : "Gerar PDF"}
                  {pdfGenerating && <svg id="spinner" aria-hidden="true" class="inline ml-1 w-4 h-4 text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                  </svg>}
                </button>
              </div>
            </section>
            <ErrorModal open={showErrorModal} onOpen={() => setShowErrorModal(false)} children={errors} />
          </div>
        </div>
      }
    </motion.div>
  );
}
